import Vue from 'vue'
import Router from 'vue-router'
import request from '@/utils/request'
import { isURL } from '@/utils/validate'
import VueI18n, { messages } from '@/i18n'
import $ from 'jquery'
const language = VueI18n.locale

const messagesConst = messages[VueI18n.locale]
let key = 'Cn'
// 判断中英文
if (language === 'zh-CN') {
  key = 'Cn'
} else {
  key = 'En'
}

Vue.use(Router)

// 页面路由(独立页面)
export const pageRoutes = [
  {
    path: '/shutdownMaintenance',
    component: () => import('@/views/pages/shutdownMaintenance'),
    name: 'shutdownMaintenance',
    meta: { title: '停机维护' }
  },
  {
    path: '/404',
    component: () => import('@/views/pages/404'),
    name: '404',
    meta: { title: '404未找到' },
    beforeEnter(to, from, next) {
      // 拦截处理特殊业务场景
      // 如果, 重定向路由包含__双下划线, 为临时添加路由
      if (/__.*/.test(to.redirectedFrom)) {
        return next(to.redirectedFrom.replace(/__.*/, ''))
      }
      next()
    }
  },
  {
    path: '/',
    component: () => import('@/views/protal/main'),
    name: 'protalMain',
    meta: { title: '门户主入口布局' }
  },
  {
    path: '/toTenantLogin',
    component: () => import('@/views/protal/tenant'),
    name: 'tenant',
    meta: { title: 'BMW 悦学苑' }
  },
  {
    path: '/register',
    component: () => import('@/views/protal/register'),
    name: 'register',
    meta: { title: '网站注册页' }
  },
  {
    path: '/person',
    component: () => import('@/views/protal/person'),
    name: 'person',
    meta: { title: '网站个人页' }
  },

  {
    path: '/forgetPassword',
    component: () => import('@/views/protal/forgetPassword'),
    name: 'forgetPassword',
    meta: { title: '忘记密码页' }
  },
  {
    path: '/account',
    component: () => import('@/views/protal/account'),
    name: 'account',
    meta: { title: '账户信息' }
  },
  {
    path: '/resume',
    component: () => import('@/views/protal/resume'),
    name: 'resume',
    meta: { title: '个人简历' }
  },
  {
    path: '/csUploadFile',
    component: () => import('@/views/modules/creationSharing/uploadFile'),
    name: 'csUploadFile',
    meta: { title: '上传作品' }
  },
  {
    path: '/csDowFile',
    component: () => import('@/views/modules/creationSharing/dow'),
    name: 'csDowFile',
    meta: { title: '上传作品' }
  },
  {
    path: '/maintain',
    component: () => import('@/views/modules/sys/maintain/maintainInfo'),
    name: 'maintain',
    meta: { title: '维护升级' }
  },
  {
    path: '/resumeEdit',
    component: () => import('@/views/modules/acdc/resume/resumeEdit'),
    name: 'resumeEdit',
    meta: { title: '编辑个人简历' }
  },
  {
    path: '/ueditor',
    component: () => import('@/views/protal/ueditor'),
    name: 'ueditor',
    meta: { title: 'ueditor' }
  },
  {
    path: '/tag',
    component: () => import('@/components/tag'),
    name: 'tag',
    meta: { title: '测试' }
  },
  {
    path: '/calendar',
    component: () => import('@/views/protal/calendar'),
    name: 'calendar',
    meta: { title: '日历' }
  },
  {
    path: '/learnMore',
    component: () => import('@/views/protal/learnMore'),
    name: 'learnMore',
    meta: { title: '了解详情' }
  },
  {
    path: '/learnMore1',
    component: () => import('@/views/protal/learnMore1'),
    name: 'learnMore1',
    meta: { title: '了解详情' }
  },
  {
    path: '/learnMore2',
    component: () => import('@/views/protal/learnMore2'),
    name: 'learnMore2',
    meta: { title: '了解详情' }
  },
  {
    path: '/information',
    component: () => import('@/views/protal/information'),
    name: 'information',
    meta: { title: '资讯' }
  },
  {
    path: '/news-detail',
    component: () => import('@/views/protal/news-detail'),
    name: 'news-detail',
    meta: { title: '新闻详情' }
  },
  {
    path: '/news-detail-main',
    component: () => import('@/views/protal/news-detail-main'),
    name: 'news-detail-main',
    meta: { title: '新闻详情' }
  },
  {
    path: '/join-BEST',
    component: () => import('@/views/protal/join-BEST'),
    name: 'addBEST',
    meta: { title: '加入BEST' }
  },
  {
    path: '/join-outlet',
    component: () => import('@/views/protal/join-outlet'),
    name: 'addBMW',
    meta: { title: '加入经销商' }
  },
  {
    path: '/academic-horizon',
    component: () => import('@/views/protal/academic-horizon'),
    name: 'academicHorizon',
    meta: { title: '学院视界' }
  },
  {
    path: '/ai-exercise',
    component: () => import('@/views/protal/ai-exercise'),
    name: 'ai-exercise',
    meta: { title: '我的AI练习'}
  }
]
const protalList = [
  { name: 'protalMain' },
  { name: 'resume' },
  { name: 'csUploadFile' },
  { name: 'csDowFile' },
  { name: 'maintain' },
  { name: 'resumeEdit' },
  { name: 'information' },
  { name: 'addBEST' },
  { name: 'academicHorizon' },
  { name: 'addBMW' },
  { name: 'manageMain' },
  { name: 'learningMain' },
  { name: 'personnelMain' },
  { name: 'reportMain' },
  { name: 'resourceMain' },
  { name: 'studyMain' },
  { name: 'userLogin' },
  { name: 'register' },
  { name: 'person' },
  { name: 'forgetPassword' },
  { name: 'learnMore' },
  { name: 'learnMore1' },
  { name: 'learnMore2' },
  { name: 'account' },
  { name: 'news-detail' },
  { name: 'ai-exercise' }
]
// 微课新增
// export const courseroutes=[
// {
//   path:"/ifo",
//   name:"ifo",
//   component:()=>import('@/views/modules/learning/course/ifo')
// }
// ]
// 模块路由(基于主入口布局页面)
export const moduleRoutes = {
  path: '/manage',
  component: () => import('@/views/manage/main'),
  name: 'manageMain',
  redirect: { name: 'home' },
  meta: { title: '管理主入口布局' },
  children: [
    { path: '/home', component: () => import('@/views/modules/home'), name: 'home', meta: { title: '首页', isTab: true } },
    {
      path: '/activiti/task-view',
      component: () => import('@/views/modules/activiti/task-view'),
      name: 'task-view',
      meta: { title: '待办任务审批', isTab: true },
      children: [
        {
          path: '/activiti/task-view/transfer-view',
          component: () => import('@/views/modules/activiti/transfer-view'),
          name: 'task-import-transfer',
          meta: { title: '转岗工作流详情/审批', isTab: true }
        },
        {
          path: '/activiti/task-view/dimission-view',
          component: () => import('@/views/modules/activiti/dimission-view'),
          name: 'task-import-dimission',
          meta: { title: '离职工作流详情/审批', isTab: true }
        },
        {
          path: '/activiti/task-view/activti-registration-approval',
          component: () => import('@/views/modules/sys/activti-registration-approval'),
          name: 'task-import-register',
          meta: { title: '注册工作流详情/审批', isTab: true }
        },
        {
          path: '/activiti/task-view/activti-registration-bmw',
          component: () => import('@/views/modules/sys/activti-registration-bmw'),
          name: 'task-import-register-bmw',
          meta: { title: '工作流详情/审批', isTab: true }
        },
        {
          path: '/activiti/task-view/activti-offering-approval',
          component: () => import('@/views/modules/rm/activti-offering-approval'),
          name: 'task-import-offering',
          meta: { title: '排期报名申请详情/审批', isTab: true }
        },
        {
          path: '/activiti/task-view/activti-classbegin-approval',
          component: () => import('@/views/modules/rm/activti-classbegin-approval'),
          name: 'task-import-classbegin',
          meta: { title: '开课申请详情/审批', isTab: true }
        },
        {
          path: '/activiti/task-view/auth-approval-view',
          component: () => import('@/views/modules/activiti/auth-approval-view'),
          name: 'task-import-auth-approval',
          meta: { title: '权限变更申请/审批', isTab: true }
        },
      ]
    },
    {
      path: '/manage/notify',
      component: () => import('@/views/modules/notify/notify'),
      name: 'notify',
      meta: { title: messagesConst.protaLogin.notify, isTab: true }
    },
    {
      path: '/online-study',
      component: () => import('@/views/protal/online-study'),
      name: 'online-study',
      meta: { title: 'WBT课程', isTab: true }
    },

    // 微课新增
    // 微课评价新增
    {
      path:"/comment-view",
      name:"comment-view",
      component:()=>import('@/views/modules/learning/course/courseComment/view'),
      meta: { title: '评价查看', isTab: true}
    },
    {
      path:"/select",
      name:"select",
      component:()=>import('@/views/modules/learning/course/CourseListSelect'),
      meta: { title: '微课管理', isTab: true}
    },
    {
      path:"/ifo",
      name:"ifo",
      component:()=>import('@/views/modules/learning/course/ifo'),
      meta: { title: '微课查看', isTab: true}
    },
    {
      path:"/operationView",
      name:"operationView",
      component:()=>import('@/views/modules/learning/course/courseOperation/OperationView'),
      meta: { title: '作业列表', isTab: true}
    },
    // 作业批改
    {
      path:"/operationMarking",
      name:"operationMarking",
      component:()=>import('@/views/modules/learning/course/courseOperation/MarkingOperation'),
      meta: { title: '作业列表', isTab: true}
    },
    {
      path:"/newCourse",
      name:"newCourse",
      component:()=>import('@/views/modules/learning/course/newCourse'),
      meta: { title: '微课新增/编辑', isTab: true}
    },
    {
      path:"/saveCourse",
      name:"saveCourse",
      component:()=>import('@/views/modules/learning/course/saveCourse'),
      meta: { title: '微课新增/编辑', isTab: true}
    },
    {
      path:"/pubCourse",
      name:"pubCourse",
      component:()=>import('@/views/modules/learning/course/CoursePub'),
      meta: { title: '微课新增/编辑', isTab: true}
    },
    {
      path: '/ai-exercise',
      component: () => import('@/views/protal/ai-exercise'),
      name: 'ai-exercise',
      meta: { title: '我的AI练习', isTab: true}
    },
    {
      path: '/redReport',
      component: () => import('@/views/modules/acdc/report/redGreenReport'),
      name: 'redReport',
      meta: { title: "红绿灯", isTab: true }
    },

    {
      path: '/charge/eightDimensions/index',
      component: () => import('@/views/modules/charge/eightDimensions/index'),
      name: 'eightDimensions',
      meta: { title: "培训辅导减免规则管", isTab: true },
    },
    {
      path: '/charge/eightDimensions/add',
      component: () => import('@/views/modules/charge/eightDimensions/add'),
      name: 'eightDimensionsAdd',
      meta: { title: "培训辅导减免规则新增", isTab: true },
    },
    {
      path: '/charge/eightDimensions/edit',
      component: () => import('@/views/modules/charge/eightDimensions/add'),
      name: 'eightDimensionsEdit',
      meta: { title: "培训辅导减免规则编辑", isTab: true },
    },
    {
      path: '/charge/eightDimensions/view',
      component: () => import('@/views/modules/charge/eightDimensions/add'),
      name: 'eightDimensionsView',
      meta: { title: "培训辅导减免规则查看", isTab: true },
    },
    {
      path: '/charge/rainingFeeQuery/index',
      component: () => import('@/views/modules/charge/rainingFeeQuery/index'),
      name: 'rainingFeeQueryView',
      meta: { title: "经销商账户", isTab: true },
    },
    {
      path: '/charge/rainingFeeQuery/distributor',
      component: () => import('@/views/modules/charge/rainingFeeQuery/distributor'),
      name: 'rainingFeeQueryDistributor',
      meta: { title: "经销商账户", isTab: true },
    },
    {
      path: '/charge/ruleSnapshot/index',
      component: () => import('@/views/modules/charge/ruleSnapshot/index'),
      name: 'ruleSnapshot',
      meta: { title: "减免规则快照查询", isTab: true },
    },
    {
      path: '/charge/ruleSnapshot/view',
      component: () => import('@/views/modules/charge/ruleSnapshot/view'),
      name: 'ruleSnapshotView',
      meta: { title: "快照详情", isTab: true },
    },
    {
      path: '/charge/rainingFeeQuery/view',
      component: () => import('@/views/modules/charge/rainingFeeQuery/view'),
      name: 'rainingFeeQuerydDetailView',
      meta: { title: "账户明细查询", isTab: true },
    },
    // 学习任务管理新增
    {
      path:"/task/detail",
      name:"taskDetail",
      component:()=>import('@/views/modules/learning/learningTask/LearningTaskMain'),
      meta: { title: '学习任务查看', isTab: true}
    },
    {
      path:"/task/create",
      name:"newTask",
      component:()=>import('@/views/modules/learning/learningTask/CreateTask'),
      meta: { title: '学习任务新建/编辑', isTab: true}
    },
    {
      path:"/task/select",
      name:"taskSelect",
      component:()=>import('@/views/modules/learning/learningTask/LearningTaskManagement'),
      meta: { title: '学习任务管理', isTab: true}
    },

    {
      path: '/charge/organizationCategory/index',
      component: () => import('@/views/modules/charge/organizationCategory/index'),
      name: 'organizationCategory',
      meta: { title: "组织类别管理", isTab: true },
    },
    {
      path: '/charge/organizationCategory/add',
      component: () => import('@/views/modules/charge/organizationCategory/add'),
      name: 'organizationCategoryAdd',
      meta: { title: "组织类别新增", isTab: true },
    },
    {
      path: '/charge/organizationCategory/edit',
      component: () => import('@/views/modules/charge/organizationCategory/add'),
      name: 'organizationCategoryEdit',
      meta: { title: "组织类别编辑", isTab: true },
    },
    {
      path: '/charge/organizationCategory/view',
      component: () => import('@/views/modules/charge/organizationCategory/add'),
      name: 'organizationCategoryView',
      meta: { title: "组织类别查看", isTab: true },
    },
    {
      path: '/charge/reduceInfo/view',
      component: () => import('@/views/modules/charge/reduceInfo/view'),
      name: 'rainingreduceInfoDetailView',
      meta: { title: "减免信息详情", isTab: true },
    },
    {
      path: '/charge/reduceInfo/viewtwo',
      component: () => import('@/views/modules/charge/reduceInfo/viewtwo'),
      name: 'rainingreduceInfoDetailViewTwo',
      meta: { title: "不减免信息详情", isTab: true },
    },
    // {
    //   path: '/sys-dict__type',
    //   component: () => import('@/views/modules/sys/dict-add-or-update'),
    //   name: 'sys-dict__type',
    //   meta: { title: "字典管理-类型", isTab: true },
    // },
    {
      path: '/404',
      component: () => import('@/views/pages/404'),
      name: '404',
      meta: { title: "404", isTab: true }
    },
    {
      path: '/shutdownMaintenance',
      component: () => import('@/views/pages/shutdownMaintenance'),
      name: 'shutdownMaintenance',
      meta: { title: "停机维护", isTab: true }
    }
  ]
}
const router = new Router({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes: pageRoutes.concat(moduleRoutes)
})

// const router = new Router({
//   mode: 'hash',
//   scrollBehavior: () => ({ y: 0 }),
//   routes: pageRoutes.concat(moduleRoutes)
// })
// router.beforeResolve((to, from, next) => {
//   console.log(to)
//   console.log(from)
// })
var tmpIFrameUrl = []
router.beforeEach((to, from, next) => {

  // 广播通知menu画面
  // Vue.prototype.$eventHub.$emit(Vue.prototype.GLOBAL.ROUTER_NAME, to.name)
  // 路由变化时关闭dialog对话框
  $('.el-dialog__close.el-icon.el-icon-close').click()
  let hasProtal = false
  // 判断是否是门户页面
  hasProtal = protalList.some((item) => {
    return item.name === to.name
  })
  if (hasProtal) {
    return next()
  }


  // 广播通知head-menu画面
  Vue.prototype.$eventHub.$emit(Vue.prototype.GLOBAL.TODO_TASK, '')



  // 判断当前页面是否在维护升级 ////  indexOf 还需要再考虑
  var sysMenuSwitch = window.SITE_CONFIG['sysMenuSwitch']
  var sysMenuSwitchOld = window.SITE_CONFIG['sysMenuSwitchOld']
  if(sysMenuSwitch !== undefined && sysMenuSwitch.length > 0 && sysMenuSwitch  && sysMenuSwitch.indexOf(to.name) !== -1){
    next({name: 'sys-maintain-maintainInfo',query:{menu:sysMenuSwitchOld[sysMenuSwitch.indexOf(to.name)]}})
    return next(false)
  }
  if(sysMenuSwitch !== undefined && sysMenuSwitch.length > 0 && sysMenuSwitch  && to.meta.iframeURL !== "" && sysMenuSwitch.indexOf(to.meta.iframeURL) !== -1){
    next({name: 'sys-maintain-maintainInfo',query:{menu:sysMenuSwitchOld[sysMenuSwitch.indexOf(to.meta.iframeURL)]}})
    return next(false)
  }


  // 添加动态(菜单)路由
  // 已添加或者当前路由为页面路由, 可直接访问
  let isPageRoute = fnCurrentRouteIsPageRoute(to, pageRoutes)



  if (window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] || isPageRoute) {

    //处理AI页面没有权限时直接输入URL打开页面问题
    if(!isPageRoute){
      let path = to.path
      if (to['meta'] && to['meta']['iframeURL']){
        let url = to['meta']['iframeURL']
        if(url.indexOf('bmw.com.cn:5700') != -1){
            // let tmpMenu = window.SITE_CONFIG['menuList']
            // tmpIFrameUrl = []
            // findIFrameUrl(tmpMenu, tmpIFrameUrl)
            // if(!tmpIFrameUrl.some( e => e == url)){
            //   console.log("not have permission")
            //   return next(true)
            // }
          return next()
        }
      }
    }// end 处理AI页面没有权限时直接输入URL打开页面问题

    if(to.name !== '' && to.name !== null && to.name !== 'home' && to.name !== '404' && window.SITE_CONFIG['mySysMenuSwitch'] !== [] && window.SITE_CONFIG['mySysMenuSwitchSta'] && to.name.indexOf('__type') < 0){

      var is404 = true
      for (const protalListKey in pageRoutes) {
        if(to.name === pageRoutes[protalListKey].name){
          is404 = false
        }
      }
      let children = moduleRoutes.children
      for (let i = 0; i < children.length; i++) {
        if(to.name === children[i].name){
          is404 = false
        }
      }
      let children1 = children[1].children
      for (let i = 0; i < children1.length; i++) {
        if(to.name === children1[i].name){
          is404 = false
        }
      }

      let mySysMenuSwitch = window.SITE_CONFIG['mySysMenuSwitch']
      // console.log(to.name)
      // console.log(to.meta.iframeURL)
      for (const mySysMenuSwitchKey in mySysMenuSwitch) {
        if(to.name === mySysMenuSwitch[mySysMenuSwitchKey]){
          is404 = false
          break
        }

        if(to.meta.iframeURL === mySysMenuSwitch[mySysMenuSwitchKey]){
          is404 = false
          break
        }

        if(to.name === '/auth/logoutIam' || to.name === '/' || to.name === 'main'){
          is404 = false
          break
        }
      }

      console.log("拦截 _ 当前访问地址")
      // console.log(to.name)

      // console.log(mySysMenuSwitch)

      let obj = {
        "userId" : JSON.parse(sessionStorage.getItem('v1user_data')).userId,
        "routes" : to.name
      }

      if(is404){
        console.log("404")
        addRoutes(obj)


       next({name: '404'})
       return next(false)

      }else {
        console.log("放行")
        // addRoutes(obj)
      }
    }

    return next()
  }




  // 获取菜单列表, 添加并全局变量保存
  // request.get('/sys/menu/nav').then((res) => {
  //   let menuList = res
  //   window.SITE_CONFIG['menuList'] = menuList
  //   next({ ...to, replace: true })
  //   // fnAddDynamicMenuRoutes(window.SITE_CONFIG['menuList'])
  // }).catch(() => {
  // })
  // next({ ...to, replace: true })
  // 获取菜单列表, 添加并全局变量保存
  request.get('/sys/menu/select').then((res) => {
    fnAddDynamicMenuRoutes(res)
    Vue.prototype.$eventHub.$emit(Vue.prototype.GLOBAL.MENU_LIST, '')
    next({ ...to, replace: true })
  }).catch(() => {
    next({ name: 'protalMain' })
  })

  // 获取维护升级的页面路径
  request.post('/sys/sysmenuswitch/getUrlList').then((res, total, code, data) => {
    let sysMenuSwitch = []
    let sysMenuSwitchOld = []

    if(code === 1){
      var urls = res.split(',')
      for (let i = 0; i <urls.length; i++) {
        sysMenuSwitchOld.push(urls[i])
        let URL = (urls[i] || '').replace(/{{([^}}]+)?}}/g, (s1, s2) => eval(s2)) // URL支持{{ window.xxx }}占位符变量
        if (isURL(URL)) {
          sysMenuSwitch.push(URL)
        }else {
          URL = URL.replace(/^\//, '').replace(/_/g, '-')
          sysMenuSwitch.push(URL.replace(/\//g, '-'))
        }
      }
    }
    window.SITE_CONFIG['sysMenuSwitch'] = sysMenuSwitch
    window.SITE_CONFIG['sysMenuSwitchOld'] = sysMenuSwitchOld
  }).catch(() => {
    next({ name: 'protalMain' })
  })

  //获取当前用户权限页面
  request.get('/sys/menu/selectMenuListAll').then((res, total, code, data) => {
    // console.log('selectMenuList')
    // console.log(data)

    let mySysMenuSwitch = []
    let mySysMenuSwitchOld = []

    if(code === 1){
      var urls = data.data
      for (let i = 0; i <urls.length; i++) {
        if(urls[i].url !== null && urls[i].url !== ""){
          mySysMenuSwitchOld.push(urls[i].url)
          let URL = (urls[i].url || '').replace(/{{([^}}]+)?}}/g, (s1, s2) => eval(s2)) // URL支持{{ window.xxx }}占位符变量
          if (isURL(URL)) {
            mySysMenuSwitch.push(URL)
          }else {
            URL = URL.replace(/^\//, '').replace(/_/g, '-')
            mySysMenuSwitch.push(URL.replace(/\//g, '-'))
          }
        }

      }
    }
    window.SITE_CONFIG['mySysMenuSwitch'] = mySysMenuSwitch
    window.SITE_CONFIG['mySysMenuSwitchOld'] = mySysMenuSwitchOld
    window.SITE_CONFIG['mySysMenuSwitchSta'] = true
    // console.log(mySysMenuSwitch)
    // console.log(mySysMenuSwitchOld)

    next({ ...to, replace: true })
  }).catch(() => {
    next({ name: 'protalMain' })
  })


})

/**
 * 判断当前路由是否为页面路由
 * @param {*} route 当前路由
 * @param {*} pageRoutes 页面路由
 */
function fnCurrentRouteIsPageRoute(route, pageRouteList = []) {
  var temp = []
  for (var i = 0; i < pageRouteList.length; i++) {
    if (route.path === pageRouteList[i].path) {
      return true
    }
    if (pageRouteList[i].children && pageRouteList[i].children.length >= 1) {
      temp = temp.concat(pageRouteList[i].children)
    }
  }
  return temp.length >= 1 ? fnCurrentRouteIsPageRoute(route, temp) : false
}

function findIFrameUrl(menus, tmpUrls = []){
  for( var i =0; i < menus.length; i++){
    var tmpMenu = menus[i]
    var url = tmpMenu.url

    if(url != null && url != ''){
      tmpUrls.push(url)
    }

    if(tmpMenu != null && tmpMenu.children && tmpMenu.children.length > 0){
       findIFrameUrl(tmpMenu.children, tmpUrls)
    }
  }
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes(menuList = [], routes = []) {
  for (var i = 0; i < menuList.length; i++) {
    // 组装路由
    var route = {
      path: '',
      component: null,
      name: '',
      meta: {
        ...window.SITE_CONFIG['contentTabDefault'],
        menuId: menuList[i].menuId,
        title: menuList[i]['name' + key]
      }
    }
    // eslint-disable-next-line
    let URL = (menuList[i].url || '').replace(/{{([^}}]+)?}}/g, (s1, s2) => eval(s2)) // URL支持{{ window.xxx }}占位符变量
    if (isURL(URL)) {
      route['path'] = route['name'] = `i-${menuList[i].menuId}`
      route['meta']['iframeURL'] = URL
      tmpIFrameUrl.push(URL)
    } else {
      URL = URL.replace(/^\//, '').replace(/_/g, '-')
      route['path'] = route['name'] = URL.replace(/\//g, '-')
      route['component'] = () => import(`@/views/modules/${URL}`)
    }
    routes.push(route)
  }
  // 添加路由
  router.addRoutes([
    {
      ...moduleRoutes,
      name: 'main-dynamic-menu',
      children: routes
    },
    { path: '*', redirect: { name: '404' } }
  ])
  window.SITE_CONFIG['dynamicMenuRoutes'] = routes
  window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] = true
}

function addRoutes(obj) {
  request.post('/sys/sysroutesintercept/save',obj).then((res, total, code, data) => {
    // console.log('/sys/sysroutesintercept/save')
    // console.log(res)
    // console.log(total)
    // console.log(code)
    // console.log(data)
  }).catch(() => {

  })
}

export default router
